export const STORAGE_KEY = 'bfa-guided-observation-v01'
export const STATE_VERSION = 1

export const EXPERIENCE_MODES = [
  { id: 'beginner', label: 'Beginner', description: 'Plain language, larger diagrams and guidance shown by default.' },
  { id: 'intermediate', label: 'Intermediate', description: 'Plain and technical terms together, with guidance available on demand.' },
  { id: 'advanced', label: 'Advanced', description: 'Compact technical wording, method notes and faster question progression.' },
]

export const MATERIAL_OPTIONS = [
  { id: 'leaves', label: 'Leaves' },
  { id: 'twigs', label: 'Twigs or buds' },
  { id: 'flowers', label: 'Flowers' },
  { id: 'fruits', label: 'Fruits' },
  { id: 'bark', label: 'Bark' },
  { id: 'habit', label: 'Whole-plant habit' },
]

export const SPECIAL_RESPONSES = [
  { id: 'not_sure', label: 'Not sure', description: 'Keep all profiles and record uncertainty.' },
  { id: 'cannot_observe', label: 'Cannot observe', description: 'The feature cannot be checked right now.' },
  { id: 'not_present', label: 'Not present on this specimen', description: 'The organ or material is not present.' },
  { id: 'not_applicable', label: 'Not applicable', description: 'The question does not apply to this observation.' },
  { id: 'deferred', label: 'Defer for later', description: 'Record this question for a later physical check.' },
]

export const CERTAINTY_OPTIONS = [
  { id: 'certain', label: 'Certain' },
  { id: 'fairly_sure', label: 'Fairly sure' },
  { id: 'tentative', label: 'Tentative' },
]

export const initialSummaryFeedback = {
  sequence: '',
  terminology: '',
  illustrations: '',
  guidance: '',
  hesitation: '',
}

